/**
 * Meta replaced Reach with Viewers on 2025-07-31; metrics either side of that date are not
 * comparable, so tooltips and labels branch on it.
 *
 * Lives here rather than in `src/app/facebook/constants.js` because `src/config.js` and
 * `src/models/metrics.enum.ts` both need it, and both are reached by more than 1600 specs —
 * importing a 3000-line feature constants module for one date comparison put that whole
 * module on their graph.
 */
// Callers hand this dayjs objects from untyped JS and `unknown` from `metrics.enum.ts`. The cast
// keeps the original JS behaviour exactly — `undefined` for a nullish date, a throw for anything
// else without `isBefore` — rather than widening the contract during a move.
type DateLike = { isBefore: (value: string, unit: string) => boolean };

const METRICS_UPGRADE_DATE = '2025-07-31';

export const isBeforeMetricsUpgrade = (date: unknown) =>
  (date as DateLike | null | undefined)?.isBefore(
    METRICS_UPGRADE_DATE,
    // Stryker disable next-line StringLiteral: equivalent mutant. METRICS_UPGRADE_DATE parses to
    // midnight, so day granularity and dayjs's default millisecond granularity agree for every
    // input — no test can tell 'day' from ''. Kept because it states the intent to compare
    // calendar days, which would start to matter if the constant ever gained a time.
    'day',
  );
